import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { GraduationCap } from 'lucide-react'
import { EntityPageHeader } from '@/shared/components'
import { useAuth } from '@/features/auth/hooks/use-auth'
import { useEtudiantByUserId } from '../hooks/use-etudiants'
import { EtudiantList } from '../components'

export function EtudiantsListPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { user } = useAuth()

  const isStudent = user?.role === 'etudiant'
  const isAdmin = user?.role === 'admin'
  const { data: myEtudiant } = useEtudiantByUserId(isStudent ? user?.id : undefined)

  useEffect(() => {
    if (isStudent && myEtudiant) {
      navigate(`/etudiants/${myEtudiant.id}`, { replace: true })
    }
  }, [isStudent, myEtudiant, navigate])

  if (isStudent) {
    return (
      <div className="flex justify-center py-12">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    )
  }

  return (
    <div>
      <EntityPageHeader
        icon={GraduationCap}
        title={t('student.list.pageTitle', 'Étudiants')}
        subtitle={isAdmin
          ? t('student.list.subtitleAdmin', 'Gestion des comptes étudiants')
          : t('student.list.subtitle', 'Gérez vos étudiants et suivez leur parcours')
        }
        createTo={isAdmin ? undefined : '/etudiants/create'}
        createLabel={t('student.list.createButton', 'Créer un étudiant')}
      />
      <EtudiantList adminMode={isAdmin} />
    </div>
  )
}
